<!-- 文章中心 -->
<template>
  <div class="new-page">
    <news-tab class="pc-comp" @getCurrentKey="getCurrentKey"></news-tab>
    <div class="space-between mytab mobile-comp">
      <div class="tag">{{ $route.query.tag }}</div>
    </div>
    <videoList v-if="$route.query.tag == '科普宣传'"></videoList>
    <download-center v-else-if="$route.query.tag == '下载中心' || $route.query.tag == '常见问题'"></download-center>
    <div v-else-if="$route.query.tag == '业务咨询'" class="content-box">
      <div class="content" v-html="content"></div>
    </div>
    <div v-else-if="$route.query.tag == '意见建议'" class="content-box">
      <div class="content" v-html="content1"></div>
    </div>
    <div v-else-if="$route.query.tag == '客户咨询会'" class="content-box">
      <div class="content" v-html="content2"></div>
    </div>
    <news-list v-else :itemkey="itemkey"></news-list>
  </div>
</template>
<script>
import newsTab from '../../components/news/news-tab.vue'
import newsList from '../../components/news/news-list.vue'
import videoList from '../../components/news/video-list.vue'
import downloadCenter from './download-center.vue'
import { getArticleDetails } from '@/api/index'

export default {
  name: '',
  props: [],
  components: { newsTab, newsList, videoList,downloadCenter },
  data() {
    return {
      content: '',
      content1: '',
      content2: '',
      itemkey: ''
    }
  },
  watch: {},
  methods: {
    getCurrentKey(itemkey) {
      this.itemkey = itemkey
    }
  },
  mounted() {
    if (this.$route.query.title == '公众服务') {
      getArticleDetails(638)
        .then((res) => {
          this.content = res.content
        })
        .finally(() => {})
      getArticleDetails(524)
        .then((res) => {
          this.content1 = res.content
        })
        .finally(() => {})
        getArticleDetails(1003)
        .then((res) => {
          this.content2 = res.content
        })
        .finally(() => {})
    }
  },
  created() {}
}
</script>

<style lang="scss" scope>
.new-page {
  width: 100%;
  flex: 1;
  margin-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 24px;
  .content-box {
    height: 435px;
    width: 100%;
    background: url(../../assets/images/report_back.webp) no-repeat;
    background-size: 100% 100%;
    padding: 50px 0px 50px 73px;

    .content {
      width: 100%;
      height: 335px;
      overflow: auto;
      padding-right: 73px;
    }
  }
}
@media screen and (max-width: 768px) {
  .new-page {
    .content-box {
      padding: 32px 0 32px 24px;
      .content {
        padding-right: 24px;
        height: 360px;
      }
    }
  }
}
</style>
